export default "__VITE_ASSET__DEUURdY4__"